module.exports = __webpack_public_path__ + "static/media/speaker_head_expressions_face_right_up.5db414b6.png";